"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line no-unused-vars
const vue_property_decorator_1 = require("vue-property-decorator");
const EBecropLegend_vue_1 = __importDefault(require("@becrop/components/EBecrop/Components/EBecropLegend.vue"));
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const lucide_vue_next_1 = require("lucide-vue-next");
const Recommendations_1 = require("@becrop/abstract/Models/Recommendations");
const NeedMap_1 = require("@becrop/abstract/Models/NeedMap");
const Score_1 = __importDefault(require("@becrop/components/Modules/Common/Models/Score"));
const BaseMapConnector_1 = require("@becrop/components/Toolkit/Common/models/BaseMapConnector");
const MapZone_1 = __importDefault(require("@becrop/components/Map/models/MapZone"));
const MapMarker_1 = __importDefault(require("@becrop/components/Map/models/MapMarker"));
const WKT_1 = __importDefault(require("ol/format/WKT"));
const style_1 = require("ol/style");
//import { Coordinate } from 'ol/coordinate';
const geom_1 = require("ol/geom");
const Controller_1 = __importDefault(require("@becrop/components/Map/Controller"));
const Utils_1 = require("@becrop/components/Map/Utils");
const proj_1 = require("ol/proj");
const ColorLibController_1 = __importDefault(require("@becrop/components/Results/Abstract/Controllers/ColorLibController"));
const ModalQRVisibility_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/ModalQRVisibility.vue"));
const ModalCertificate_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/ModalCertificate.vue"));
const ModalExportMapReport_vue_1 = __importDefault(require("./ModalExportMapReport.vue"));
const ModalsSelectsModuleResults_vue_1 = __importDefault(require("./ModalsSelectsModuleResults.vue"));
const GraphCertificateScreenshot_vue_1 = __importDefault(require("./GraphCertificateScreenshot.vue"));
const MetricRankTag_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/Metrics/MetricRankTag.vue"));
const ComparisonTrigger_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/ComparisonTrigger.vue"));
const MapTooltip_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/MapTooltip.vue"));
const MapTooltipRecommendationSection_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/MapTooltipRecommendationSection.vue"));
const MapTooltipMetricSection_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/MapTooltipMetricSection.vue"));
const MapTooltipNeedMapSection_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/MapTooltipNeedMapSection.vue"));
const BarChart_vue_1 = __importDefault(require("@becrop/components/Common/BarChart.vue"));
const BarChartItem_vue_1 = __importDefault(require("@becrop/components/Common/BarChartItem.vue"));
const DynamicLegend_vue_1 = __importDefault(require("@becrop/components/Common/DynamicLegend.vue"));
const FieldMapTooltip_vue_1 = __importDefault(require("@becrop/components/Common/FieldMapTooltip.vue"));
const HeaderMap_vue_1 = __importDefault(require("./HeaderMap.vue"));
const FooterMap_vue_1 = __importDefault(require("./FooterMap.vue"));
const ProjectControl_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/Projects/ProjectControl.vue"));
const MixpanelHandler_1 = __importDefault(require("@becrop/components/Modules/Common/Models/MixpanelHandler"));
const debounce_1 = require("@common/tsutils/debounce");
const ExporterSetupRaster_1 = require("@becrop/components/Map/ModelsT/ExporterSetupRaster");
const EventTracker_1 = __importDefault(require("@becrop/abstract/Utils/EventTracker"));
const GeoTIFF_1 = __importDefault(require("ol/source/GeoTIFF"));
const Recommendation_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/Recommendations/components/Recommendation.vue"));
const Acreage_1 = __importDefault(require("@becrop/components/Modules/Common/Models/Acreage"));
//import { crop } from '@becrop/components/Modules/Common/interfaces/subclient_i';
const eBeCropIcon_vue_1 = __importDefault(require("@becrop/components/DashboardSingle/components/StatusTags/eBeCropIcon.vue"));
const easing_1 = require("ol/easing");
let PanelViewMap = class PanelViewMap extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.samplesVisibility = false;
        this.MAP_CONTROLLER = new Controller_1.default();
        this.createMapZones = false;
        this.mixpanelHandler = new MixpanelHandler_1.default();
        this.colorController = new ColorLibController_1.default();
        this.titleModal = '';
        this.subtitleModal = '';
        this.optionsModal = [];
        this.btnModalText = '';
        this.typeModal = '';
        this.modalOpen = false;
        this.loadingModalDeploy = false;
        this.connector = new BaseMapConnector_1.BaseMapConnector(this.map_config);
        //statusVisibility = this.currentProjectDelivery.certificate.is_public;
        this.isDeployModalExport = false;
        this.isMapScreenshot = false;
        this.isLoadingReport = false;
        this.isLoadingReportAnon = false;
        this.toastActive = false;
        this.certificateError = '';
        this.isDeployModalQRVisibility = false;
        this.isDeployModalCertificate = false;
        this.hasEbecropToast = false;
        this.NOT_COMPARABLE_PROJECTS_KEYS = ['rate'];
        this.fieldActive = new Recommendations_1.FieldRecommendation({}, []);
        /*     fieldActiveToFarm: any = {
              id: 0,
              name: '',
              extension: 0,
              geodata: '',
              crop: {
                name: '',
                logo: '',
                color: ''
              },
              unit: '',
              recommendations: []
            }; */
        this.eventTracker = new EventTracker_1.default();
        this.maxValuePHCH = '';
        this.minValuePHCH = '';
        this.AI_GEN_CROPS_VALID = ['Corn, Maize', 'Soybean', 'Maíz', 'Haba de soja', 'Soja', 'Maïs'];
        this.statesEbecrop = [];
    }
    get projections() {
        return { dataProjection: 'EPSG:4326', featureProjection: 'EPSG:3857' };
    }
    focusField(field) {
        console.log(field);
        const feature = new WKT_1.default().readFeature(field.polygon, this.projections);
        this.MAP_CONTROLLER.map.getView().fit(feature.getGeometry().getExtent(), { duration: 700, easing: easing_1.easeOut, padding: [50, 50, 50, 50] });
    }
    parseFieldIntoFieldWithRecomms(f) {
        const newF = new Recommendations_1.FieldRecommendation(Object.assign({}, f), []);
        newF.recommendations = f.recommendations;
        return newF;
    }
    findRecommendations(r) {
        let parsedRecs = [];
        if (r.length > 0) {
            if (r[0].needMap) {
                const recSet = r.find((rec) => rec.needMap == this.currentNeedMap.category.slug);
                if (recSet)
                    parsedRecs = recSet.products;
            }
            else {
                parsedRecs = r;
            }
        }
        return parsedRecs;
    }
    get acreageHelper() {
        var _a, _b, _c;
        if ((_a = this.fieldActive) === null || _a === void 0 ? void 0 : _a.extension) {
            const ac = this.buildAcreage((_b = this.fieldActive) === null || _b === void 0 ? void 0 : _b.extension, (_c = this.fieldActive) === null || _c === void 0 ? void 0 : _c.unit);
            ac.switchToAcres();
            return ac.shortLabel;
        }
        else {
            this.fieldActive.acreage.switchToAcres();
            return this.fieldActive.acreage.shortLabel;
        }
    }
    get isFarmWithRecomms() {
        return (this.currentProjectDelivery.farmAssociated ||
            (this.currentFarm && this.entityType === 'farms')) && this.isNeedMaps;
    }
    triggerAIGen() {
        this.$emit('triggerAIGen');
    }
    buildAcreage(ext, unit) {
        return new Acreage_1.default(ext, unit);
    }
    get chosenScale() {
        let scale = this.scale;
        if (this.dimension === 'phch') {
            scale = 'phch';
        }
        else {
            if (this.mapSideBarPanel === 'need-maps') {
                if (this.currentNeedMap.category.slug === 'rate') {
                    scale = 'cert';
                }
                else {
                    scale = 'need';
                }
            }
        }
        return scale;
    }
    get hasProjects() {
        const params = new URLSearchParams(window.location.search);
        const projectId = params.get('projectId');
        const areaId = params.get('areaId');
        return projectId && areaId ? true : false;
    }
    get recommendation() {
        var _a, _b;
        return (_b = (_a = this.fieldActive) === null || _a === void 0 ? void 0 : _a.recommendations) === null || _b === void 0 ? void 0 : _b.find((recom) => {
            return recom.needMap === this.currentNeedMap.category.slug;
        });
    }
    get recommendationFarmToField() {
        return this.currentFarm.recommendations;
    }
    get displayScaleLegend() {
        if (this.dimension === 'phch') {
            if (this.currentProjectDelivery.meta.area_id > 0 && this.currentPhChMetric.rasterUrl.length > 5) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            if (this.currentProjectDelivery.meta.area_id > 0) {
                return true;
            }
            else {
                return false;
            }
        }
    }
    openEbecropToast() {
        this.hasEbecropToast = true;
        setTimeout(() => {
            this.hasEbecropToast = false;
        }, 10000);
    }
    ebecropRasterSetup(url, name) {
        const color = [
            'interpolate',
            ['linear'],
            ['band', 1],
            0,
            [0, 0, 0, 0],
            0.00001,
            '#E52721',
            0.49,
            '#E52721',
            0.49999,
            '#FF9A51',
            0.5,
            '#FF9A51',
            1,
            '#E6D581',
        ];
        return { geotiffConfig: { url: url, nodata: 255, max: 3, min: 0 }, layerConfig: { color: color, name: name, zindex: 1 } };
    }
    async drawRasterEBecrop(url, name, center) {
        const exportSetup = this.ebecropRasterSetup(url, name);
        const geotiffConfig = exportSetup.geotiffConfig;
        const layerConfig = exportSetup.layerConfig;
        await this.rasterBuilder.drawRaster(geotiffConfig, layerConfig, center);
    }
    get drawBuilder() {
        return this.MAP_CONTROLLER.drawBuilder;
    }
    ;
    async drawCurrentFarm() {
        var _a;
        if (this.mapSideBarPanel === 'farms') {
            (_a = (0, Utils_1.findLayerById)('zone-layer', this.MAP_CONTROLLER.map)) === null || _a === void 0 ? void 0 : _a.getSource().clear();
            (0, Utils_1.removeLayersById)('draw-basecopy-layer', this.MAP_CONTROLLER.map);
            let drawableFarm = null;
            if (this.currentFarm)
                drawableFarm = this.currentFarm;
            if (this.currentProjectDelivery.farmAssociated)
                drawableFarm = this.currentProjectDelivery.farmAssociated;
            if (drawableFarm) {
                const polygons = [];
                drawableFarm.fields.forEach((field) => {
                    if (field.geodata.length > 0) {
                        polygons.push(field.geodata);
                        this.MAP_CONTROLLER.zoneBuilder.drawZone(new MapZone_1.default({
                            geoData: field.geodata,
                            fillColor: '#85df4f40',
                            strokeColor: '#85df4f',
                            enableHoverInteraction: true,
                            enableSelectInteraction: true,
                            zoneName: `${field.name}${field.id}`,
                            centerZone: false,
                            avg: 0,
                            markers: [],
                            preciseResult: false,
                            crop: field.crop.name
                        }), 700, [250, 250, 250, 250]);
                    }
                });
                if (drawableFarm.is_generative_zone) {
                    this.openEbecropToast();
                }
                const polygonsWkt = polygons.map(Utils_1.parseWKT);
                const combinedGeometry = new geom_1.GeometryCollection(polygonsWkt);
                const extent = (0, proj_1.transformExtent)(combinedGeometry.getExtent(), 'EPSG:4326', 'EPSG:3857');
                this.MAP_CONTROLLER.map.getView().fit(extent, { duration: 0, easing: easing_1.easeOut, padding: [50, 50, 50, 50] });
                //center(this.map, extent, 700, [100,100,100,500]);
            }
            else {
            }
        }
        if (this.mapSideBarPanel === 'metrics' && this.currentProjectDelivery.fields.length > 0) {
            (0, Utils_1.removeLayersById)('zone-layer', this.MAP_CONTROLLER.map);
            this.applyStyleBlockMode();
        }
    }
    async drawAIGen() {
        var _a;
        (_a = (0, Utils_1.findLayerById)('zone-layer', this.MAP_CONTROLLER.map)) === null || _a === void 0 ? void 0 : _a.getSource().clear();
        (0, Utils_1.removeLayersById)('draw-basecopy-layer', this.MAP_CONTROLLER.map);
        if (this.isNeedMaps) {
            let drawableFarm = null;
            if (this.currentFarm)
                drawableFarm = this.currentFarm;
            if (this.currentProjectDelivery.farmAssociated)
                drawableFarm = this.currentProjectDelivery.farmAssociated;
            if (drawableFarm) {
                const polygons = [];
                drawableFarm.fields.forEach((field) => {
                    polygons.push(field.geodata);
                    this.MAP_CONTROLLER.zoneBuilder.drawZone(new MapZone_1.default({
                        geoData: field.geodata,
                        fillColor: '#00000000',
                        strokeColor: '#6c3fb8',
                        enableHoverInteraction: true,
                        enableSelectInteraction: true,
                        zoneName: `${field.name}${field.id}`,
                        centerZone: false,
                        avg: 0,
                        markers: [],
                        preciseResult: false,
                        crop: field.crop.name
                    }), 700, [250, 250, 250, 250]);
                });
                if (drawableFarm.is_generative_zone) {
                    // this.openEbecropToast();
                    this.statesEbecrop = this.currentFarm.generative_zones;
                    this.statesEbecrop.forEach(async (state) => {
                        //this.drawRasterEBecrop(state.url, state.state, false);
                        await this.drawRasterEBecrop(state.url, `raster-layer-${state.name}-high`, false);
                        const layer = await (0, Utils_1.findLayerById)(`raster-layer-${state.name}-high`, this.MAP_CONTROLLER.map);
                        if (!layer) {
                            await this.drawRasterEBecrop(state.url, `raster-layer-${state.name}-high`, false);
                        }
                        else {
                            layer.setVisible(true);
                        }
                    });
                    //this.drawBuilder.recortarLayerConWKT(this.map_config.provider, this.map_config.apikey!, 'zone-layer');
                    // ******************* Crop clipping filtering
                    const zoneLayer = this.map.getLayers().getArray().find((layer) => layer.get('id') === 'zone-layer');
                    if (zoneLayer) {
                        const source = zoneLayer.getSource();
                        let features = source.getFeatures();
                        const wktFormat = new WKT_1.default();
                        const wktStrings = features
                            .filter((feature) => this.AI_GEN_CROPS_VALID.includes(feature.get('crop')))
                            .map((feature) => {
                            const geometry = feature.getGeometry();
                            if (geometry) {
                                return wktFormat.writeGeometry(geometry);
                            }
                            else {
                                console.info('geometry not fount');
                            }
                        });
                        this.drawBuilder.trimLayerWithCrops(this.map_config.provider, this.map_config.apikey, 'zone-layer', wktStrings);
                    }
                    // *******************
                }
                else {
                    this.statesEbecrop.forEach((state) => {
                        (0, Utils_1.visibilityLayer)(false, `raster-layer-${state.name}-high`, this.MAP_CONTROLLER.map);
                    });
                }
                const polygonsWkt = polygons.map(Utils_1.parseWKT);
                const combinedGeometry = new geom_1.GeometryCollection(polygonsWkt);
                const extent = (0, proj_1.transformExtent)(combinedGeometry.getExtent(), 'EPSG:4326', 'EPSG:3857');
                this.MAP_CONTROLLER.map.getView().fit(extent, { duration: 0, easing: easing_1.easeOut, padding: [50, 50, 50, 50] });
                //center(this.map, extent, 700, [100,100,100,500]);
            }
        }
        // this.changeFieldsStyle() // We need to revalidate if it's necesary
    }
    async paintRasterCurrentField(state) {
        /* const source = new GeoTIFF({
            sources: [ { url: state.url, nodata: 255, max: 3, min: 0 } ],
                interpolate: false,
            });
        const rasterView = await source.getView();
        const extent = rasterView.extent!;
        const extentInProjection = transformExtent(extent, 'EPSG:4326', 'EPSG:3857');
        const polygonExtension = getExtensionOl(this.currentFarm.geodata);
        const doTheyIntersect = intersects(extentInProjection, polygonExtension);
        if(doTheyIntersect){
        } */
        await this.drawRasterEBecrop(state.url, `raster-layer-${state.name}-high`, false);
    }
    findFieldActive(name) {
        var _a;
        if (name && name.length > 0) {
            if (this.entityType === 'projects') {
                this.fieldActive = this.currentProjectDelivery.fields.find((f) => `${f.name}${f.id}` === name);
                if (this.currentProjectDelivery.farmAssociated && this.currentFarm) {
                    const fieldFromFarm = (_a = this.currentFarm) === null || _a === void 0 ? void 0 : _a.fields.find((f) => f.id === this.fieldActive.id);
                    if (fieldFromFarm.recommendations.length > 0 && this.fieldActive.recommendations.length == 0) {
                        this.fieldActive.recommendations = fieldFromFarm.recommendations;
                    }
                }
            }
            if (this.entityType === 'farms') {
                const fieldFromFarm = this.currentFarm.fields.find((f) => `${f.name}${f.id}` === name);
                fieldFromFarm.acreage = new Acreage_1.default(this.fieldActive.extension, this.fieldActive.unit);
                this.fieldActive = this.parseFieldIntoFieldWithRecomms(fieldFromFarm);
            }
        }
    }
    setFieldAsActiveFromParent() {
        var _a, _b;
        const latestFieldSelected = `${(_a = this.fieldActive) === null || _a === void 0 ? void 0 : _a.name}${(_b = this.fieldActive) === null || _b === void 0 ? void 0 : _b.id}`;
        this.findFieldActive(this.fieldActiveKey);
        if (this.fieldActiveKey.length < 1) {
            this.overlayBuilder.visibilityOverlay(this.polygonConnectorId, false);
            this.MAP_CONTROLLER.zoneSelected = null;
            this.MAP_CONTROLLER.resetZoneLayerStyles();
            this.MAP_CONTROLLER.setZoneSelected(null);
            return;
        }
        if (this.fieldActive && this.fieldActiveKey && this.currentProjectDelivery.meta.type !== 'rate') {
            this.MAP_CONTROLLER.zoneSelected = null;
            this.MAP_CONTROLLER.resetZoneLayerStyles();
            this.MAP_CONTROLLER.setZoneSelected(this.addSelectStyleByFeature(this.fieldActiveKey));
        }
        /*             if(!this.fieldActiveKey.includes('undefined') || this.fieldActive.id !== -1) {
                    if(this.entityType == 'projects'){
                        // Change FieldActive only if it's different than current
                        if(this.currentProjectDelivery.farmAssociated) {
                            this.fieldActive = this.currentFarm.fields.find((f:any) => `${f.name}${f.id}` === this.fieldActiveKey)
                            this.fieldActive.acreage = new Acreage(this.fieldActive.extension, this.fieldActive.unit)
                            //this.changeFieldsStyle();
                        } else {
                            this.fieldActive = this.currentProjectDelivery.fields.find((f:FieldRecommendation) => `${f.name}${f.id}` === this.fieldActiveKey)
                            //this.changeFieldsStyle();
                        }
                    } else {
                        this.fieldActive = this.currentFarm.fields.find((f:any) => `${f.name}${f.id}` === this.fieldActiveKey)
                        //this.changeFieldsStyle();
                    }
    
                    if(this.fieldActive) {
                        this.MAP_CONTROLLER.setZoneSelected(this.addSelectStyleByFeature(`${this.fieldActive.name}${this.fieldActive.id}`))
                    }
                } */
    }
    setFieldAsActiveFromMap() {
        var _a, _b, _c;
        const newFieldSelected = (_a = this.MAP_CONTROLLER.zoneSelected) === null || _a === void 0 ? void 0 : _a.get('name');
        const latestFieldSelected = `${(_b = this.fieldActive) === null || _b === void 0 ? void 0 : _b.name}${(_c = this.fieldActive) === null || _c === void 0 ? void 0 : _c.id}`;
        if (newFieldSelected !== latestFieldSelected) {
            this.findFieldActive(newFieldSelected);
            this.$emit('updateFieldActiveKey', newFieldSelected);
        }
        //this.drawFieldActive(newFieldSelected)
        // Check if there's a selected zone
        //  - YES: Check if selected zone is the same as already active
        //              - YES: Do nothing
        //              - NO: Assign Active and emit
        //  - NO: Assign Active and emit
    }
    drawFieldActive(name) {
        /*
                MAYBE DEPRECATED
                console.log('watch field active')
                console.log(this.fieldActive) */
        //this.MAP_CONTROLLER.zoneSelected = null;
        if (this.fieldActive && this.fieldActive.id !== -1 && this.currentProjectDelivery.meta.type !== 'rate') {
            if (this.entityType === 'projects') {
                if (this.fieldActive.polygon !== '-') {
                    this.MAP_CONTROLLER.setZoneSelected(this.addSelectStyleByFeature(name));
                }
                else {
                    this.overlayBuilder.visibilityOverlay(this.polygonConnectorId, false);
                }
                this.eventTrackerListener('selectFieldInMap', {
                    id: this.fieldActive.id,
                    field: this.fieldActive.name,
                    farmId: this.fieldActive.areaID
                });
            }
            if (this.entityType === 'farms') {
                if (this.fieldActive.geodata !== '-') {
                    this.MAP_CONTROLLER.setZoneSelected(this.addSelectStyleByFeature(name));
                }
                else {
                    this.overlayBuilder.visibilityOverlay(this.polygonConnectorId, false);
                }
                this.eventTrackerListener('selectFieldInMap', {
                    id: this.fieldActive.id,
                    field: this.fieldActive.name,
                    farmId: this.fieldActive.areaID
                });
            }
        }
    }
    /*     @Watch('fieldActiveToFarm')
        drawFieldActiveFarm() {
            this.MAP_CONTROLLER.zoneSelected = null;
            if(this.fieldActiveToFarm?.polygon !== '-') {
                this.MAP_CONTROLLER.setZoneSelected(this.addSelectStyleByFeature(`${this.fieldActiveToFarm?.name}${this.fieldActiveToFarm?.id}`))
            } else {
                this.overlayBuilder.visibilityOverlay(this.polygonConnectorId, false);
            }
            
            if(this.fieldActiveToFarm.id !== -1){
                this.eventTrackerListener('selectFieldInMap', {
                    id: this.fieldActiveToFarm?.id,
                    field: this.fieldActiveToFarm?.name,
                    farmId: this.fieldActiveToFarm?.areaID
                });
            }
    
            this.$emit('updateFieldActiveKey', `${this.fieldActiveToFarm?.name}${this.fieldActiveToFarm?.id}`)
        } */
    get currentFieldName() {
        var _a, _b;
        return ((_b = (_a = this.MAP_CONTROLLER) === null || _a === void 0 ? void 0 : _a.currentzoneSelected) === null || _b === void 0 ? void 0 : _b.get('name')) || '';
    }
    get gisFieldSelectedByName() {
        var _a;
        const gisField = this.currentProjectDelivery.getGisFieldByName((_a = this.MAP_CONTROLLER.currentzoneSelected) === null || _a === void 0 ? void 0 : _a.get('name'));
        return gisField;
    }
    get fieldSelectedByName() {
        var _a;
        const gisFieldData = this.gisFieldSelectedByName;
        const myField = this.currentProjectDelivery.getFieldByName((_a = this.MAP_CONTROLLER.currentzoneSelected) === null || _a === void 0 ? void 0 : _a.get('name'));
        if (gisFieldData.id > 0)
            myField.setAcreage(gisFieldData.metadata.extension.value, gisFieldData.metadata.extension.unit);
        return myField;
    }
    get config() {
        return {
            tiffUrl: this.tiffUrl,
            isNeedMaps: this.isNeedMaps,
            needMap: this.getCurrentNeedMap,
            isComparison: this.isComparisonMode,
            isMainPanel: this.isMainPanel,
            dimension: this.dimension,
            bioMetric: this.currentMetric,
            phchMetric: this.currentPhChMetric,
            vsMetric: this.currentComparisonMetric,
            vsPhChMetric: this.currentComparisonPhChMetric,
            baseState: this.baseState ? true : false
        };
    }
    get hasDynamicLegend() {
        if (this.currentMetric.stats.pixels_data) {
            const percentages = this.currentMetric.stats.pixels_data.pixels_percentage;
            const totalPercentages = percentages.rank_1 + percentages.rank_2 + percentages.rank_3 + percentages.rank_4 + percentages.rank_5;
            const extensions = this.currentMetric.stats.pixels_data.pixels_extension;
            const totalExtensions = extensions.rank_1 + extensions.rank_2 + extensions.rank_3 + extensions.rank_4 + extensions.rank_5;
            if (totalPercentages > 0 || totalExtensions > 0)
                return true;
            else
                return false;
        }
        else {
            return false;
        }
    }
    // *** DYNAMIC LEGEND ***
    get valuesPercentage() {
        const percentages = this.currentMetric.stats.pixels_data.pixels_percentage;
        return {
            vhigh: `${percentages.rank_5.toFixed(0)}`,
            high: `${percentages.rank_4.toFixed(0)}`,
            medium: `${percentages.rank_3.toFixed(0)}`,
            low: `${percentages.rank_2.toFixed(0)}`,
            vlow: `${percentages.rank_1.toFixed(0)}`,
        };
    }
    get valuesAcreage() {
        const extensions = this.currentMetric.stats.pixels_data.pixels_extension;
        return {
            vhigh: `${extensions.rank_5.toFixed(0)}`,
            high: `${extensions.rank_4.toFixed(0)}`,
            medium: `${extensions.rank_3.toFixed(0)}`,
            low: `${extensions.rank_2.toFixed(0)}`,
            vlow: `${extensions.rank_1.toFixed(0)}`,
        };
    }
    // *** NEW TOOLTIP ***
    get barChartConfig() {
        const gisField = this.currentProjectDelivery.gisFields.find((gisField) => gisField.name === this.fieldActive.name);
        if (this.fieldActive && this.fieldActive.areaID === -1)
            return null;
        if (gisField === null || gisField === void 0 ? void 0 : gisField.results_stats.metrics) {
            const currentFieldMetric = gisField === null || gisField === void 0 ? void 0 : gisField.results_stats.metrics.find((metric) => metric.metric_code === this.currentMetric.code_name);
            // Verificamos que currentFieldMetric y sus propiedades existan
            if (!currentFieldMetric || !currentFieldMetric.stats || !currentFieldMetric.stats.pixels_data) {
                return null;
            }
            const formatValue = (value) => (value === 0 ? value : value.toFixed(3));
            const getConfig = (getColorMethod) => {
                return [1, 2, 3, 4, 5].map((rank) => ({
                    rank: this.colorController[getColorMethod](rank.toString()),
                    acreage: formatValue(currentFieldMetric.stats.pixels_data.pixels_extension[`rank_${rank}`]),
                    percentage: formatValue(currentFieldMetric.stats.pixels_data.pixels_percentage[`rank_${rank}`])
                }));
            };
            return this.scale === 'hlt' ? getConfig('getDiseasesColor') : getConfig('getRankColor');
        }
        return null;
    }
    get isComparisonTriggerDisplayed() {
        const comparableProjects = this.projectsAvailableCurated;
        const conditions = [
            // Not ScreenShot
            !this.isMapScreenshot,
            !this.isMapScreenshotProp,
            // Not a NeedMap
            !this.isNeedMaps,
            // CurrentProject is suitable
            !this.NOT_COMPARABLE_PROJECTS_KEYS.includes(this.currentProjectBuilt.project_type),
            // At least two comparable projects
            (comparableProjects.length >= 1) ? true : false,
            // Panels Logic
            (this.isMainPanel && !this.isDoblePanelDeployed) || (!this.isMainPanel && this.isDoblePanelDeployed),
            this.entityType === 'projects'
        ];
        return conditions.every((c) => c === true);
    }
    get comparisonTriggerMode() {
        // 0 loading
        // 1 main panel
        // 2 secondary panel
        if (this.loadingDetailStatus.type.length > 0) {
            return 0;
        }
        else {
            if (this.isMainPanel)
                return 1;
            return 2;
        }
    }
    get currentNeedMapCategory() {
        var _a;
        return ((_a = this.currentNeedMap) === null || _a === void 0 ? void 0 : _a.category) || new NeedMap_1.NeedMapsCategory({
            slug: '-',
            title: '-',
            caption: '-',
            description: '-',
            enabled: false,
            reverseScale: false,
            typeScale: ''
        });
    }
    get scoreCurrentPoint() {
        var _a;
        return new Score_1.default((_a = this.currentProjectDelivery.findSampleByMetric(this.MAP_CONTROLLER.currentMarkerSelected.get('code'), this.config)) === null || _a === void 0 ? void 0 : _a.score, this.typeProjectSelected).value;
    }
    get tiffUrl() {
        var _a;
        return this.isComparisonMode ? this.currentComparisonMetric.baseMetric.rasterUrl : (_a = this.currentMetric) === null || _a === void 0 ? void 0 : _a.rasterUrl;
    }
    get agInsightInSelectedFieldForSelectedMetric() {
        return this.currentProjectDelivery.hasFieldAgInsightForMetric(this.fieldActive, this.currentMetric);
    }
    get currentMetricInSelectedField() {
        var _a;
        return (_a = this.fieldActive) === null || _a === void 0 ? void 0 : _a.findDisplayedMetric(this.config);
    }
    get projectsAvailableCurated() {
        if (this.isMainPanel && this.isDoblePanelDeployed) {
            return this.projectsAvailable.filter((p) => p.project_type !== 'rate' && p.project_type !== 'farm').map((pr) => pr);
        }
        return this.projectsAvailable;
    }
    get fileName() {
        return (this.currentProjectDelivery.meta.name +
            '_' +
            this.currentProjectDelivery.meta.type +
            '_' +
            this.currentProjectDelivery.proposal.name +
            ' [BeCrop Portal]');
    }
    get typeProjectSelected() {
        if (this.currentProjectDelivery) {
            return this.currentProjectDelivery.meta.type;
        }
        return 'rate';
    }
    get isLightProvider() {
        const lightProviderKeys = ['OpenStreetMaps'];
        if (lightProviderKeys.includes(this.map_config.provider)) {
            return true;
        }
        return false;
    }
    get isNeedMaps() {
        return this.mapSideBarPanel === 'need-maps';
    }
    get isMetrics() {
        return this.mapSideBarPanel === 'metrics';
    }
    get map() {
        return this.MAP_CONTROLLER.map;
    }
    addSelectStyleByFeature(name) {
        return (0, Utils_1.addSelectStyleByFeature)(name, this.overlayBuilder, this.map, this.polygonConnectorId);
    }
    renderAsArea() {
        if (this.currentProjectDelivery.meta.type === 'rate') {
            const color = this.colorController.getCategoryColor(this.currentProjectDelivery.certificate.category.toLowerCase());
            this.MAP_CONTROLLER.zoneBuilder.drawZone(new MapZone_1.default({
                geoData: this.currentProjectDelivery.meta.polygon,
                fillColor: `${color}70`,
                strokeColor: color,
                centerZone: true,
                enableHoverInteraction: false,
                avg: 0,
                markers: [],
                preciseResult: false
            }), (!this.createMapZones) ? 0 : 700, [100, 100, 100, 500]);
        }
        // Si se quiere renderizar por area otro tipo de proyecto no rate, debería hacerse desde aqui
    }
    renderAsFields() {
        this.applyStyleBlockMode();
    }
    handleChangeInProjectDelivery() {
        if (this.entityType === 'projects' && this.currentProjectDelivery.fields.length > 0) {
            this.overlayBuilder.visibilityOverlay(this.polygonConnectorId, false);
            this.createMapZones = false;
            this.dismissModalQRVisibility();
            (0, Utils_1.removeLayerById)('zone-layer', this.map);
            (0, Utils_1.removeLayerById)('point-layer', this.map);
            (0, Utils_1.removeLayersById)('raster-layer', this.map);
            this.drawSamples();
            //this.updateFieldNumber();
            //this.generateFields();
            if (this.currentProjectDelivery.meta.type === 'rate') {
                this.renderAsArea();
            }
            else {
                this.applyStyleBlockMode();
            }
            if (this.isNeedMaps) {
                this.drawNeedMapRaster();
            }
            if (this.isMetrics) {
                this.drawRaster();
            }
            this.samplesVisibility = false;
            this.isDeployModalExport = false;
            //this.statusVisibility = this.currentProjectDelivery.certificate.is_public;
        }
    }
    drawSamples() {
        if (this.currentProjectDelivery.meta.type === 'rate') {
            this.currentProjectDelivery.samples.forEach((marker) => {
                this.pointBuilder.drawPoint(new MapMarker_1.default({ geoData: marker.coordenates, enableHoverInteraction: true, enableSelectInteraction: true, color: '#fff', code: marker.code }));
            });
        }
        else {
            this.currentProjectDelivery.samples.forEach((marker) => {
                const sample = this.currentProjectDelivery.findSampleByMetric(marker.code, this.config);
                if (sample) {
                    this.pointBuilder.drawPoint(new MapMarker_1.default({ geoData: marker.coordenates, enableHoverInteraction: true, enableSelectInteraction: true, color: sample.color, code: marker.code }));
                }
            });
        }
        (0, Utils_1.visibilityLayer)(false, 'point-layer', this.map);
        this.overlayBuilder.visibilityOverlay(this.pointsConnectorId, false);
    }
    downloadReportEmit() {
        this.deployModalExport();
    }
    mounted() {
        this.MAP_CONTROLLER.create(this.mapConnectorId, this.map_config.provider, this.map_config.apikey, this.polygonConnectorId, this.pointsConnectorId, this.recommendationConnector, 13, 0, 17);
        this.MAP_CONTROLLER.addSelectInteractions();
        if (this.mapSideBarPanel === 'farms') {
            this.drawCurrentFarm();
        }
    }
    eventTrackerListener(eventName, eventValues) {
        this.eventTracker.trackEvent(eventName, eventValues);
    }
    zoomIn() {
        this.MAP_CONTROLLER.zoomIn();
        this.eventTrackerListener('mapZoomIn', { currentZoom: this.MAP_CONTROLLER.map.getView().get('zoom') });
    }
    zoomOut() {
        this.MAP_CONTROLLER.zoomOut();
        this.eventTrackerListener('mapZoomOut', { currentZoom: this.MAP_CONTROLLER.map.getView().get('zoom') });
    }
    exchangeSamples() {
        this.samplesVisibility = !this.samplesVisibility;
    }
    setRendering() {
        this.$emit('setRendering');
    }
    unsetRendering() {
        this.$emit('unsetRendering');
    }
    get zoneBuilder() {
        return this.MAP_CONTROLLER.zoneBuilder;
    }
    get pointBuilder() {
        return this.MAP_CONTROLLER.pointBuilder;
    }
    get rasterBuilder() {
        return this.MAP_CONTROLLER.rasterBuilder;
    }
    get overlayBuilder() {
        return this.MAP_CONTROLLER.overlayBuilder;
    }
    get getCurrentNeedMap() {
        return this.currentNeedMap;
    }
    get baseState() {
        const notBaseStates = ['metrics', 'need-maps', 'recommendations', 'farms'];
        if (this.mapSideBarPanel.length === 0)
            return true;
        if (notBaseStates.includes(this.mapSideBarPanel)) {
            if (this.mapSideBarPanel == 'need-maps') {
                if (this.currentNeedMap.category.slug == '-')
                    return true;
            }
            if (this.mapSideBarPanel == 'metrics' && this.entityType === 'farms') {
                return true;
            }
        }
        if (this.entityType === 'projects' && this.mapSideBarPanel === 'farms') {
            return true;
        }
        if (this.mapSideBarPanel === 'projects')
            return true;
        if (this.mapSideBarPanel === 'farms')
            return true;
        if (this.mapSideBarPanel === 'fields')
            return true;
        if (this.mapSideBarPanel === 'home')
            return true;
        return false;
    }
    drawFields() {
        const polygons = [];
        this.currentProjectDelivery.fields.forEach((field) => {
            if ((0, Utils_1.getExtension)(field.polygon) >= 1) {
                polygons.push(field.polygon);
                this.MAP_CONTROLLER.zoneBuilder.drawZone(new MapZone_1.default({
                    geoData: field.polygon,
                    fillColor: field.fillColor(this.config),
                    strokeColor: field.strokeColor(this.config),
                    enableHoverInteraction: true,
                    enableSelectInteraction: true,
                    zoneName: `${field.name}${field.id}`,
                    centerZone: false,
                    avg: field.score(this.config),
                    markers: field.samples,
                    preciseResult: field.isGISField ? true : false,
                    crop: field.crop.name
                }), 700, [100, 100, 100, 500]);
            }
        });
        const polygonsWkt = polygons.map(Utils_1.parseWKT);
        const combinedGeometry = new geom_1.GeometryCollection(polygonsWkt);
        const extent = (0, proj_1.transformExtent)(combinedGeometry.getExtent(), 'EPSG:4326', 'EPSG:3857');
        this.MAP_CONTROLLER.map.getView().fit(extent, { duration: 0, easing: easing_1.easeOut, padding: [50, 50, 50, 50] });
        //center(this.map, extent, 700, [100,100,100,500]);
    }
    applyStyleBlockMode() {
        this.drawFields();
        this.createMapZones = true;
    }
    changeFieldsStyle() {
        var _a;
        const fieldsFeatures = (_a = (0, Utils_1.findLayerById)('zone-layer', this.map)) === null || _a === void 0 ? void 0 : _a.getSource().getFeatures();
        if (fieldsFeatures && this.createMapZones) {
            fieldsFeatures.forEach((fieldFeat) => {
                var _a;
                const fieldName = fieldFeat.get('name');
                const field = this.currentProjectDelivery.fields.find((f) => `${f.name}${f.id}` === fieldName);
                if (field) {
                    const fill = new style_1.Fill({ color: field.fillColor(this.config) });
                    const stroke = new style_1.Stroke({
                        color: this.MAP_CONTROLLER.zoneSelected && (((_a = this.MAP_CONTROLLER.zoneSelected) === null || _a === void 0 ? void 0 : _a.get('name')) === field.name) ?
                            '#FFF' :
                            field.strokeColor(this.config), width: 3
                    });
                    const newStyle = new style_1.Style({ fill: fill, stroke: stroke });
                    fieldFeat.setStyle(newStyle);
                    fieldFeat.set('style', newStyle);
                }
            });
        }
    }
    triggerZoneStyleUpdater() {
        try {
            if (this.entityType == 'projects') {
                (0, Utils_1.visibilityLayers)(false, 'raster-layer', this.map);
                (0, Utils_1.removeLayerById)('point-layer', this.map);
                this.overlayBuilder.visibilityOverlay(this.pointsConnectorId, false);
                //this.overlayBuilder.visibilityOverlay(this.polygonConnectorId, false);
                this.overlayBuilder.visibilityOverlay(this.recommendationConnector, false);
                this.changeFieldsStyle();
                this.drawSamples();
                if (this.samplesVisibility) {
                    (0, Utils_1.visibilityLayer)(true, 'point-layer', this.map);
                }
                this.currentProjectDelivery.samples.forEach((marker) => {
                    const sample = this.currentProjectDelivery.findSampleByMetric(marker.code, this.config);
                    if (sample !== undefined) {
                        this.pointBuilder.changeIndividualMarkerStyle(marker.code, {
                            iconImg: '/images/map/resources/tube-icon.svg',
                            color: sample.color
                        });
                    }
                });
            }
            if (this.entityType == 'farms') {
                this.drawCurrentFarm();
            }
        }
        catch (e) {
            console.log(e);
        }
    }
    async drawRaster() {
        this.setRendering();
        if (!this.baseState) {
            if (this.tiffUrl && !this.isNeedMaps) {
                const hasHLT = this.currentMetric.code_name === 'HLT' && this.currentMetric.type_code === 'GS';
                const name = `raster-layer-${this.currentMetric.code_name}-${this.currentProjectDelivery.meta.area_id}`;
                const color = hasHLT ? (0, ExporterSetupRaster_1.getResultConfigRasterTo5Scale)(this.scale) : (0, ExporterSetupRaster_1.getResultConfigRaster)(this.scale);
                const maxRange = hasHLT ? 5 : 100;
                await this.rasterBuilder.drawRaster({ url: this.tiffUrl, nodata: 255, max: maxRange, min: 0 }, { color: color, name: name, zindex: 5 });
            }
            else {
                (0, Utils_1.visibilityLayers)(false, 'raster-layer', this.map);
            }
        }
        else {
            (0, Utils_1.visibilityLayers)(false, 'raster-layer', this.map);
        }
        this.unsetRendering();
    }
    triggerNeedMaps() {
        (0, Utils_1.visibilityLayers)(false, 'raster-layer', this.map);
        this.overlayBuilder.visibilityOverlay(this.pointsConnectorId, false);
        //this.overlayBuilder.visibilityOverlay(this.polygonConnectorId, false);
        this.overlayBuilder.visibilityOverlay(this.recommendationConnector, false);
        if (this.isNeedMaps && this.currentNeedMap.category.slug === 'aigen') {
            this.drawAIGen();
        }
        else {
            if (this.isNeedMaps) {
                this.drawNeedMapRaster();
                this.changeFieldsStyle();
            }
        }
    }
    applyFarmDefaultStyle() {
        var _a;
        const farmMapFeatures = (_a = (0, Utils_1.findLayerById)('zone-layer', this.map)) === null || _a === void 0 ? void 0 : _a.getSource().getFeatures();
        farmMapFeatures.forEach((feature) => {
            feature.setStyle(new style_1.Style({
                fill: new style_1.Fill({ color: '#85df4f40' }),
                stroke: new style_1.Stroke({ color: '#85df4f', width: 3 }),
                zIndex: 10
            }));
        });
    }
    triggerSideBarPanel() {
        this.overlayBuilder.visibilityOverlay(this.polygonConnectorId, false);
        try {
            if (this.mapSideBarPanel.length > 0) {
                if (!this.isNeedMaps) {
                    this.statesEbecrop.forEach((state) => {
                        (0, Utils_1.visibilityLayer)(false, `raster-layer-${state.name}-high`, this.MAP_CONTROLLER.map);
                    });
                    (0, Utils_1.removeLayersById)('draw-basecopy-layer', this.MAP_CONTROLLER.map);
                }
                if (this.entityType === 'projects') {
                    // Quitar rasters
                    (0, Utils_1.visibilityLayers)(false, 'raster-layer', this.map);
                    if (this.mapSideBarPanel !== 'farms') {
                        (0, Utils_1.removeLayersById)('draw-basecopy-layer', this.map);
                    }
                    if (!this.baseState) {
                        // Actualizar fields
                        (0, Utils_1.removeLayerById)('zone-layer', this.map);
                        this.handleChangeInProjectDelivery();
                        this.changeFieldsStyle();
                        (0, Utils_1.removeLayersById)('recommendations-indicator-layer', this.map);
                        this.samplesVisibility = false;
                        this.overlayBuilder.visibilityOverlay(this.pointsConnectorId, false);
                        this.overlayBuilder.visibilityOverlay(this.recommendationConnector, false);
                        // Dibujar nuevos raster
                        if (this.dimension === 'phch') {
                            this.drawRasterPhch();
                        }
                        else {
                            if (this.isNeedMaps) {
                                if (this.currentNeedMap.category.slug == 'aigen') {
                                    this.drawAIGen();
                                }
                                else {
                                    this.drawNeedMapRaster();
                                }
                            }
                            else if (this.isMetrics && this.tiffUrl && this.tiffUrl.length > 0) {
                                this.drawRaster();
                            }
                        }
                    }
                    else {
                        if (!this.isNeedMaps) {
                            this.statesEbecrop.forEach((state) => {
                                (0, Utils_1.visibilityLayer)(false, `raster-layer-${state.name}-high`, this.MAP_CONTROLLER.map);
                            });
                        }
                        this.changeFieldsStyle();
                    }
                }
                if (this.entityType === 'farms') {
                    if (this.isNeedMaps && this.currentFarm.is_generative_zone) {
                        this.drawAIGen();
                    }
                    else {
                        this.drawCurrentFarm();
                    }
                }
            }
            else {
                this.statesEbecrop.forEach((state) => {
                    (0, Utils_1.visibilityLayer)(false, `raster-layer-${state.name}-high`, this.MAP_CONTROLLER.map);
                });
                (0, Utils_1.visibilityLayers)(false, 'raster-layer', this.map);
                (0, Utils_1.removeLayersById)('draw-basecopy-layer', this.MAP_CONTROLLER.map);
                if (this.baseState) {
                    if ((this.currentProjectDelivery.meta.type === 'farm' && this.currentProjectDelivery.farmAssociated) || this.currentFarm) {
                        this.drawCurrentFarm();
                    }
                    else {
                        this.changeFieldsStyle();
                    }
                }
            }
        }
        catch (e) {
            console.log(e);
        }
        if (this.mapSideBarPanel === 'fields' && this.entityType === 'farms') {
            this.applyFarmDefaultStyle();
        }
        else if (this.mapSideBarPanel === 'fields' && this.entityType === 'projects') {
            (0, Utils_1.removeLayersById)('raster-layer', this.map);
        }
        if (this.mapSideBarPanel === 'metrics') {
            this.handleChangeInProjectDelivery();
        }
    }
    async drawNeedMapRaster() {
        var _a;
        if (this.isNeedMaps) {
            if (!this.baseState) {
                this.setRendering();
                if (this.currentNeedMap && this.currentNeedMap.results.raster_url !== '#URL') {
                    //this.MAP_CONTROLLER.activeLoadingMap()
                    let color;
                    color = this.currentNeedMap.category.getRasterScaleColor();
                    const raster_url = (_a = this.currentNeedMap.results.raster_url) !== null && _a !== void 0 ? _a : '';
                    const limits = this.currentNeedMap.category.getRasterScaleLimits();
                    await this.MAP_CONTROLLER.rasterBuilder.drawRaster({
                        url: raster_url,
                        nodata: 255,
                        max: limits.max,
                        min: limits.min
                    }, {
                        color: color,
                        name: `raster-layer-${this.currentNeedMap.category.slug}-${this.currentProjectDelivery.meta.area_id}`,
                        zindex: 5
                    });
                    //this.MAP_CONTROLLER.removeLoadingMap();
                }
                this.unsetRendering();
            }
            else {
                (0, Utils_1.visibilityLayers)(false, 'raster-layer', this.map);
            }
        }
        else {
            if (this.isMetrics) {
                this.drawRaster();
            }
        }
    }
    async drawRasterPhch() {
        this.setRendering();
        if (!this.baseState) {
            //this.MAP_CONTROLLER.activeLoadingMap()
            (0, Utils_1.visibilityLayers)(false, 'raster-layer', this.map);
            const rasterPhchUrl = this.currentPhChMetric.rasterUrl;
            let max = '';
            let min = '';
            if (this.dimension === 'phch' && rasterPhchUrl.length > 0) {
                const source = new GeoTIFF_1.default({
                    sources: [{ url: rasterPhchUrl }],
                    interpolate: false,
                });
                this.rasterBuilder.drawRaster({
                    url: rasterPhchUrl,
                    nodata: null,
                    max: null,
                    min: null
                }, {
                    color: null,
                    name: `raster-layer-phch-${this.currentPhChMetric.name}-${this.currentPhChMetric.type_code}`,
                    zindex: 5
                });
                await new Promise((resolve) => {
                    source.on('change', () => {
                        if (source.getState() === 'ready') {
                            max = `${source.metadata_[0][0].STATISTICS_MAXIMUM}`;
                            min = `${source.metadata_[0][0].STATISTICS_MINIMUM}`;
                            resolve();
                        }
                    });
                });
            }
            this.maxValuePHCH = parseFloat(max).toFixed(1);
            this.minValuePHCH = parseFloat(min).toFixed(1);
            //this.MAP_CONTROLLER.removeLoadingMap()
        }
        else {
            (0, Utils_1.visibilityLayers)(false, 'raster-layer', this.map);
        }
        this.unsetRendering();
    }
    async changeDimension() {
        this.changeFieldsStyle();
        if (this.dimension === 'phch') {
            this.drawRasterPhch();
        }
        else if (this.dimension === 'bio') {
            this.drawRaster();
        }
    }
    resetDimension() {
        if (this.typeProjectSelected === 'rate') {
            this.samplesVisibility = false;
        }
    }
    modifySamplesVisibility() {
        //---
        if (!this.samplesVisibility) {
            (0, Utils_1.visibilityLayer)(false, 'point-layer', this.map);
            this.overlayBuilder.visibilityOverlay(this.pointsConnectorId, false);
        }
        else {
            this.overlayBuilder.visibilityOverlay(this.recommendationConnector, false);
            (0, Utils_1.visibilityLayer)(true, 'point-layer', this.map);
        }
    }
    currentExt() {
        /*         this.connector.downloadMapKML(this.mapBG, this.mapStroke, this.currentProjectDelivery.meta.name); */
    }
    mapScreenshot(value) {
        this.isMapScreenshot = value;
        this.$emit('isMapScreenshot', this.isMapScreenshot);
    }
    deployModalQRVisibility() {
        this.isDeployModalQRVisibility = true;
    }
    dismissModalQRVisibility() {
        this.isDeployModalQRVisibility = false;
    }
    deployModalCertificate() {
        this.isDeployModalCertificate = true;
    }
    dismissModalCertificate() {
        this.isDeployModalCertificate = false;
    }
    deployModalQR() {
        this.deployModalQRVisibility();
    }
    handleDownloadMainDeliverable() {
        if (this.typeProjectSelected !== 'rate') {
            this.deployModalExport();
        }
        else {
            this.deployModalCertificate();
        }
    }
    deployModalExport() {
        this.isDeployModalExport = true;
    }
    dismissModalExport() {
        this.isDeployModalExport = false;
    }
    updateProjectSelected(model) {
        this.$emit('updateProjectSelected', model);
    }
    updateFarmSelected(f) {
        this.$emit('updateFarmSelected', f);
    }
    loadPreviousMetric() {
        this.$emit('loadPreviousMetric');
    }
    loadNextMetric() {
        this.$emit('loadNextMetric');
    }
    toggleDoblePanel() {
        if (this.isDoblePanelDeployed) {
            this.dismissDoblePanel();
        }
        else {
            this.deployDoblePanel();
            this.eventTrackerListener('deployCompareMode', true);
        }
    }
    deployDoblePanel() {
        this.$emit('deployDoblePanel');
    }
    dismissDoblePanel() {
        this.$emit('dismissDoblePanel');
    }
    deployModal(title, subtitle, options, btn, type) {
        this.titleModal = title;
        this.subtitleModal = subtitle;
        this.optionsModal = options;
        this.btnModalText = btn;
        this.typeModal = type;
        this.modalOpen = true;
    }
    dismissToast() {
        this.toastActive = false;
    }
    dismissModal() {
        this.modalOpen = false;
    }
    async triggerActionFromModal() {
        this.loadingModalDeploy = true;
        if (this.titleModal === 'Download Certificate') {
            try {
                const call = fetch('/data/results/certificate/' + this.currentProjectBuilt.area_id).then((response) => {
                    if (response.status === 200) {
                        window.open('/data/results/certificate/' + this.currentProjectBuilt.area_id, '_blank');
                    }
                    else {
                        this.certificateError = "You don't own this report!";
                    }
                });
            }
            catch (error) {
                console.log(error);
            }
        }
        this.loadingModalDeploy = false;
    }
    downloadFarmPDF() {
        console.log('bajar farm PDF');
    }
    async downloadUniqueReportAnonymised() {
        this.isLoadingReportAnon = true;
        this.toastActive = false;
        const reportCode = this.MAP_CONTROLLER.currentMarkerSelected.get('code');
        try {
            const sample = this.currentProjectDelivery.samples.find((s) => s.code === reportCode);
            await sample.downloadReportPDF(true);
        }
        catch (e) {
            this.toastActive = true;
        }
        this.isLoadingReportAnon = false;
    }
    async openUniqueReport() {
        this.isLoadingReport = true;
        const reportCode = this.MAP_CONTROLLER.currentMarkerSelected.get('code');
        const url = '/data/results/report/pdf/' + reportCode;
        this.toastActive = false;
        try {
            const sample = this.currentProjectDelivery.samples.find((s) => s.code === reportCode);
            await sample.downloadReportPDF(false);
        }
        catch (e) {
            this.toastActive = true;
        }
        this.isLoadingReport = false;
    }
    async openFpdfReport(field) {
        var _a, _b;
        this.isLoadingReport = true;
        const fieldMapName = ((_a = this.MAP_CONTROLLER.currentzoneSelected) === null || _a === void 0 ? void 0 : _a.get('name')) ? (_b = this.MAP_CONTROLLER.currentzoneSelected) === null || _b === void 0 ? void 0 : _b.get('name') : '';
        try {
            const currentGisField = this.currentProjectDelivery.gisFields.find((gisField) => {
                return `${gisField.name}${gisField.id}` === fieldMapName;
            });
            const needsAccurateReport = currentGisField !== undefined &&
                currentGisField.id !== -1 &&
                currentGisField.results_stats.metrics !== undefined &&
                currentGisField.results_stats.metrics.length > 0;
            const gisFieldId = currentGisField !== undefined && currentGisField.id !== -1 ? currentGisField.id : -1;
            if (gisFieldId > 0) {
                await field.downloadFieldReportPDF(this.currentProjectDelivery.meta.project_id.toString(), this.currentProjectDelivery.meta.area_id.toString(), needsAccurateReport, gisFieldId, fieldMapName);
            }
            else {
                throw new Error(`Error fetching or opening PDF, Field ID not valid: ${gisFieldId}`);
            }
        }
        catch (error) {
            console.error('Error fetching or opening PDF:', error);
        }
        this.isLoadingReport = false;
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], PanelViewMap.prototype, "mapSideBarPanel", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], PanelViewMap.prototype, "downloadReportAction", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], PanelViewMap.prototype, "map_config", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], PanelViewMap.prototype, "data", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], PanelViewMap.prototype, "pointsConnectorId", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], PanelViewMap.prototype, "mapConnectorId", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], PanelViewMap.prototype, "isDoblePanelDeployed", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], PanelViewMap.prototype, "isComparisonMode", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], PanelViewMap.prototype, "isMainPanel", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], PanelViewMap.prototype, "isMapScreenshotProp", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'bio' })
], PanelViewMap.prototype, "dimension", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'std' })
], PanelViewMap.prototype, "scale", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], PanelViewMap.prototype, "entityType", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Array, default: [] })
], PanelViewMap.prototype, "projectsAvailable", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], PanelViewMap.prototype, "currentProjectBuilt", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], PanelViewMap.prototype, "disabledProject", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], PanelViewMap.prototype, "currentProjectDelivery", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], PanelViewMap.prototype, "currentMetric", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], PanelViewMap.prototype, "currentPhChMetric", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], PanelViewMap.prototype, "currentNeedMap", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], PanelViewMap.prototype, "showRecommendations", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], PanelViewMap.prototype, "currentComparisonMetric", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], PanelViewMap.prototype, "currentComparisonPhChMetric", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], PanelViewMap.prototype, "loadingDetailStatus", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], PanelViewMap.prototype, "polygonConnectorId", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], PanelViewMap.prototype, "isBiome", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], PanelViewMap.prototype, "isITMember", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], PanelViewMap.prototype, "recommendationConnector", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], PanelViewMap.prototype, "fieldActiveKey", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], PanelViewMap.prototype, "currentFarm", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: [] })
], PanelViewMap.prototype, "farms", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('currentFarm'),
    (0, vue_property_decorator_1.Watch)('currentProjectDelivery.fields')
], PanelViewMap.prototype, "drawCurrentFarm", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('fieldActiveKey')
], PanelViewMap.prototype, "setFieldAsActiveFromParent", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('MAP_CONTROLLER.zoneSelected')
], PanelViewMap.prototype, "setFieldAsActiveFromMap", null);
__decorate([
    (0, debounce_1.Debounce)(100)
], PanelViewMap.prototype, "renderAsFields", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('currentProjectDelivery'),
    (0, vue_property_decorator_1.Watch)('currentProjectDelivery.fields')
], PanelViewMap.prototype, "handleChangeInProjectDelivery", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('downloadReportAction')
], PanelViewMap.prototype, "downloadReportEmit", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('currentMetric')
], PanelViewMap.prototype, "triggerZoneStyleUpdater", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('tiffUrl')
], PanelViewMap.prototype, "drawRaster", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('currentNeedMap')
], PanelViewMap.prototype, "triggerNeedMaps", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('mapSideBarPanel')
], PanelViewMap.prototype, "triggerSideBarPanel", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('dimension'),
    (0, vue_property_decorator_1.Watch)('currentPhChMetric')
], PanelViewMap.prototype, "changeDimension", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('typeProjectSelected')
], PanelViewMap.prototype, "resetDimension", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('samplesVisibility')
], PanelViewMap.prototype, "modifySamplesVisibility", null);
PanelViewMap = __decorate([
    (0, vue_property_decorator_1.Options)({
        name: 'PanelViewMap',
        components: {
            FieldMapTooltip: FieldMapTooltip_vue_1.default,
            DynamicLegend: DynamicLegend_vue_1.default,
            MapTooltipMetricSection: MapTooltipMetricSection_vue_1.default,
            MapTooltipNeedMapSection: MapTooltipNeedMapSection_vue_1.default,
            MapTooltipRecommendationSection: MapTooltipRecommendationSection_vue_1.default,
            ProjectControl: ProjectControl_vue_1.default,
            ScaleLegend: bmk_ui_framework_1.ScaleLegend,
            Modal: bmk_ui_framework_1.Modal,
            HeaderMap: HeaderMap_vue_1.default,
            FooterMap: FooterMap_vue_1.default,
            GraphCertificateRate: bmk_ui_framework_1.GraphCertificateRate,
            ModalsSelectsModuleResults: ModalsSelectsModuleResults_vue_1.default,
            MapAttributions: bmk_ui_framework_1.MapAttributions,
            Button: bmk_ui_framework_1.Button,
            Plus: lucide_vue_next_1.Plus,
            Minus: lucide_vue_next_1.Minus,
            Tag: bmk_ui_framework_1.Tag,
            WarningDiamondIcon: bmk_ui_framework_1.WarningDiamondIcon,
            Toasts: bmk_ui_framework_1.Toasts,
            ModalExportMapReport: ModalExportMapReport_vue_1.default,
            RateLogo: bmk_ui_framework_1.RateLogo,
            GraphCertificateScreenshot: GraphCertificateScreenshot_vue_1.default,
            CodeSnippet: bmk_ui_framework_1.CodeSnippet,
            ArrowDown: lucide_vue_next_1.ArrowDown,
            Glasses: lucide_vue_next_1.Glasses,
            TubeIcon: bmk_ui_framework_1.TubeIcon,
            MetricRankTag: MetricRankTag_vue_1.default,
            MapTooltip: MapTooltip_vue_1.default,
            ModalQRVisibility: ModalQRVisibility_vue_1.default,
            ModalCertificate: ModalCertificate_vue_1.default,
            ComparisonTrigger: ComparisonTrigger_vue_1.default,
            BarChart: BarChart_vue_1.default,
            BarChartItem: BarChartItem_vue_1.default,
            EbecropLegend: EBecropLegend_vue_1.default,
            RecommendationItemBox: Recommendation_vue_1.default,
            eBeCropIcon: eBeCropIcon_vue_1.default
        },
    })
], PanelViewMap);
exports.default = PanelViewMap;
